import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { takeUntil } from 'rxjs/operators';
import { UnsubscribeComponent } from '../../../generals/Components';
import { AdminModuleLog, AdminModuleLogDetail } from '../../../interfaces/interfaces';
import { ApiService } from '../../../services/api.service';

@Component({
  selector: 'app-modulelog',
  templateUrl: './modulelog.component.html',
  styleUrls: ['./modulelog.component.scss']
})
export class ModulelogComponent extends UnsubscribeComponent {

  moduleId: number = null;
  logs: AdminModuleLogDetail[] = [];

  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private apiService: ApiService
  ) {
    super();
    this.moduleId = this.config.data.moduleId;
    this.getLog();
  }

  getLog(): void {
    this.apiService.getModuleLog(this.config.data.moduleId).pipe(takeUntil(this.unsubscribe)).subscribe(({logs}) => {
      this.logs = logs.map((adminModuleLog: AdminModuleLog) => ({
        adminModuleLog,
        opened: false,
        log: null
      }));
    });
  }

  switchLogDetail(adminModuleLogDetail: AdminModuleLogDetail): void {
    adminModuleLogDetail.opened = !adminModuleLogDetail.opened;
    if (adminModuleLogDetail.log !== null) {
      return;
    }
    this.apiService.getModuleLogDetail(this.moduleId, adminModuleLogDetail.adminModuleLog.id).pipe(takeUntil(this.unsubscribe)).subscribe(({log}) => {
      adminModuleLogDetail.log = log;
    });
  }

  close(): void {
    this.ref.close();
  }

}
